var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-scroller"},[_c('nav-bar'),_c('div',{staticClass:"container-fluid page-body-wrapper"},[_c('side-bar'),_c('div',{staticClass:"main-panel"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }